export class ApiError extends Error {
    constructor({ message, errors, journey, dropCode, correlationId, status, data }) {
        super(message || (errors && errors[0] && errors[0].message) || 'API request failed');
        this.name = 'ApiError';
        this.errors = errors || [];
        this.journey = journey || null;
        this.dropCode = dropCode || null;
        this.correlationId = correlationId || null;
        this.status = status || null;
        // Soft-failure responses (e.g. DUPLICATE_MOBILE on /registration/signup)
        // carry recovery context in `data` — leadId, otpSent, state, etc. The
        // adapter / call site needs it to resume the existing lead instead of
        // bailing.
        this.data = data || null;
    }

    get firstCode() {
        return this.errors[0] && this.errors[0].code;
    }
}

export class NetworkError extends Error {
    constructor({ cause, url }) {
        // EW-I6374: `message` must be safe to surface to the user — it used to be
        // `Network error calling <full API url>: Failed to fetch`, which leaked the
        // internal endpoint to the screen on any fetch failure. Keep the generic,
        // user-facing copy here; the technical detail stays on `url` / `cause` (and
        // `detail`) for console logging and Datadog, never shown to the customer.
        super('Network error. Please check your connection and try again.');
        this.name = 'NetworkError';
        this.cause = cause;
        this.url = url;
        this.detail = `Network error calling ${url}: ${cause && cause.message}`;
    }
}
